const SERVER_URL = 'https://portfolio-server-kappa-weld.vercel.app'
export default SERVER_URL;